"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Selects = require("../Selects");

var _CheckboxesModule = _interopRequireDefault(require("./Checkboxes.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1 3l2.5 3L8 1"
});

var SelectElement = function SelectElement() {
  return _react.default.createElement("div", {
    className: _CheckboxesModule.default.btn
  }, _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "7",
    viewBox: "0 0 9 7",
    className: _CheckboxesModule.default.checkmark
  }, _ref));
};

var _ref3 =
/*#__PURE__*/
_react.default.createElement(SelectElement, null);

var Checkbox = function Checkbox(_ref2) {
  var className = _ref2.className,
      isActive = _ref2.isActive,
      disabled = _ref2.disabled,
      props = _objectWithoutProperties(_ref2, ["className", "isActive", "disabled"]);

  return _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(_CheckboxesModule.default.checkbox, className, isActive && _CheckboxesModule.default.selected, disabled && _CheckboxesModule.default.disabled)
  }, props), _ref3);
};

exports.Checkbox = Checkbox;

var _ref4 =
/*#__PURE__*/
_react.default.createElement(SelectElement, null);

var Checkboxes = function Checkboxes(props) {
  return _react.default.createElement(_Selects.LabeledSelect, _extends({
    stateReducer: _Selects.toggleMultiple,
    selectElement: _ref4,
    selectedClassName: _CheckboxesModule.default.selected,
    disabledClassName: _CheckboxesModule.default.disabled
  }, props));
};

var _default = Checkboxes;
exports.default = _default;